<template>
  <Head title="Kinerja" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Kinerja Program Studi', href: route('kinerja.index') },
          ]"
        />
        <div
          class="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between"
        >
          <div>
            <h1 class="text-2xl font-bold text-gray-900 sm:text-3xl">
              Kinerja Program Studi
            </h1>
          </div>
          <div class="flex items-center gap-4">
            <p class="text-sm text-gray-500">
              Dokumen Kinerja Program Studi /
              {{ instrumens.data[0].akreditasi.akreditasi }}
            </p>
          </div>
        </div>

        <div class="col-span-1 p-4 lg:col-span-2">
          <!-- Search Input -->
          <div class="relative mb-4 text-sm text-gray-800">
            <div
              class="absolute top-0 bottom-0 left-0 flex items-center pl-2 text-gray-500 pointer-events-none"
            >
              <MagnifyingGlassVue />
            </div>
            <input
              v-model="search"
              type="text"
              autocomplete="off"
              placeholder="Cari Nama..."
              id="search"
              class="block w-full py-2 pl-10 text-gray-900 border-0 rounded-lg ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>

          <!-- Table -->
          <div class="overflow-x-auto">
            <table class="min-w-full table-auto">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    ID
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    Intrumen
                  </th>

                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Jenis Dokumen
                  </th>

                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <!-- Empty for Action Buttons -->
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <!-- Table Rows -->
                <tr v-for="(instru, index) in instrumens.data" :key="instru.id">
                  <td class="px-3 py-4 text-gray-500 whitespace-nowrap">
                    {{ index + 1 }}.
                  </td>
                  <td class="px-3 py-4 text-gray-500 whitespace-nowrap">
                    {{ instru.instrumen }}
                  </td>

                  <td class="px-3 py-4 text-gray-500 whitespace-nowrap">
                    {{ instru.jenisdokumen.nama }}
                  </td>

                  <td class="flex items-center justify-center py-4 space-x-2">
                    <span
                      v-if="counts[instru.id]?.kinerja === 0"
                      class="inline-flex items-center justify-center rounded-full border border-red-500 px-2.5 py-0.5 text-red-700"
                    >
                      <p class="text-sm whitespace-nowrap">
                        {{ counts[instru.id]?.kinerja || 0 }}
                      </p>
                    </span>
                    <span
                      v-else
                      class="inline-flex items-center justify-center rounded-full border border-emerald-500 px-2.5 py-0.5 text-emerald-700"
                    >
                      <p class="text-sm whitespace-nowrap">
                        {{ counts[instru.id]?.kinerja || 0 }}
                      </p>
                    </span>

                    <Link
                      :href="route('kinerja.adddocument', instru.slugid)"
                      class="px-2 py-1 text-xs font-medium text-gray-800 bg-white border border-gray-400 rounded shadow hover:bg-gray-100"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        class="size-5"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5ZM10 8a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5A.75.75 0 0 1 10 8Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ModalAddDokumen
            v-model:isOpen="isModalOpen"
            :title="form.id ? 'Edit Dokumen' : 'Tambah Dokumen'"
            :jenis="props.jenisdoks"
            :prodis="props.prodis"
            :repository="form.id ? props.repositories : null"
          />

          <!-- Pagination -->
          <div class="flex justify-center mt-4">
            <Pagination
              :data="instrumens"
              :updatedPageNumber="updatedPageNumber"
            />
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { useForm, usePage, router } from "@inertiajs/vue3";
import { ref, computed, watch, onMounted } from "vue";

import Pagination from "@/Components/Pagination.vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";
import ModalAddDokumen from "@/Components/Kinerja/ModalAddDokumen.vue";
import Header from "@/Components/Header.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Container from "@/Layouts/Container.vue";
import Swal from "sweetalert2";

const isModalOpen = ref(false);
const selectedJenis = ref(false);
const props = defineProps({
  instrumens: {
    type: Object,
    required: true,
  },
  jenisdoks: {
    type: Object,
    required: true,
  },
  prodis: {
    type: Object,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
});

/**
 * @param pagination
 */

let search = ref(usePage().props.search || ""),
  pageNumber = ref(1);

let studentUrl = computed(() => {
  let url = new URL(route("kinerja.index"));
  url.searchParams.set("page", pageNumber.value); // Use 'set' to replace existing params
  if (search.value) {
    url.searchParams.set("search", search.value); // Use 'set' for search
  }

  return url;
});

const updatedPageNumber = (link) => {
  const params = new URLSearchParams(link.url.split("?")[1]);
  pageNumber.value = params.get("page");
};

watch(
  () => studentUrl.value,
  (updatedStudentUrl) => {
    router.visit(updatedStudentUrl.toString(), {
      preserveScroll: true,
      preserveState: true,
      replace: true,
    });
  }
);

watch(
  () => search.value,
  (value) => {
    if (value) {
      pageNumber.value = 1; // Reset to page 1 when search is updated
    }
  }
);
const form = useForm({
  id: null,
});

/**
 * function menghitung jumlah dokumen berdasarkan instrumen
 * @param id
 * @returns {Promise<void>}
 */
const counts = ref({});

const fetchCount = async (id) => {
  try {
    const response = await axios.get(`countinstrumen/${id}`);
    counts.value[id] = response.data;
  } catch (error) {
    console.error("Error fetching count:", error);
  }
};
onMounted(() => {
  props.instrumens.data.forEach((instru) => {
    fetchCount(instru.id);
  });
});
/**
 * End of function menghitung jumlah dokumen berdasarkan instrumen
 */
</script>
